module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-detail/modal-history-change/modal-history-change.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-detail/modal-history-change/modal-history-change.component.sass
// module chunks = main